import { inject, Service } from "@angular/core";
import { BasicHttpClientService } from "app/shared/services/basic-http-client.service";
import { environment } from "environments/environment";
import {
  GeneralFieldsDTO,
  GeneralFieldsTypeEnum,
} from "../../models/customer/customer.model";
import { UtilityFunctions } from "app/shared/utilities/functions.models";
import { PagedResponse } from "app/shared/models/paged-response.model";
import { Observable } from "rxjs";

@Service()
export class GeneralFieldsService {
  private _httpClient = inject(BasicHttpClientService);
  private _baseUrl: string;

  constructor() {
    this._baseUrl = environment.urls.apiUrl.url;
  }

  getList(
    loaderId: string,
    searchString?: string,
    type?: GeneralFieldsTypeEnum,
    maxResultCount?: number,
    sorting?: string,
    skipCount?: number,
    customerId?: number,
  ): Observable<PagedResponse<GeneralFieldsDTO>> {
    const params = UtilityFunctions.buildParams(
      ["searchString", searchString],
      ["type", type],
      ["customerId", customerId],
      ["maxResultCount", maxResultCount],
      ["sorting", sorting],
      ["skipCount", skipCount],
    );
    return this._httpClient.get<PagedResponse<GeneralFieldsDTO>>(
      `${this._baseUrl}/general-fields`,
      { params },
      loaderId,
    );
  }

  getGeneralFieldsForCustomer(
    loaderId: string,
    customerId: number,
    type?: GeneralFieldsTypeEnum,
  ): Observable<PagedResponse<GeneralFieldsDTO>> {
    const params = UtilityFunctions.buildParams(
      ["customerId", customerId],
      ["type", type],
    );
    return this._httpClient.get<PagedResponse<GeneralFieldsDTO>>(
      `${this._baseUrl}/customers/${customerId}/general-fields`,
      { params },
      loaderId,
    );
  }

  createGeneralFieldForCustomer(
    loaderId: string,
    customerId: number,
    generalFieldId: number,
  ): Observable<PagedResponse<GeneralFieldsDTO>> {
    return this._httpClient.post<PagedResponse<GeneralFieldsDTO>>(
      `${this._baseUrl}/customers/${customerId}/general-fields/${generalFieldId}`,
      {},
      null,
      loaderId,
    );
  }

  updateGeneralFieldForCustomer(
    loaderId: string,
    customerId: number,
    generalFieldId: number,
  ): Observable<PagedResponse<GeneralFieldsDTO>> {
    return this._httpClient.post<PagedResponse<GeneralFieldsDTO>>(
      `${this._baseUrl}/customers/${customerId}/general-fields/${generalFieldId}`,
      {},
      null,
      loaderId,
    );
  }

  createGeneralField(loaderId: string, generalField: GeneralFieldsDTO) {
    return this._httpClient.post(
      `${this._baseUrl}/general-fields`,
      generalField,
      null,
      loaderId,
    );
  }

  updateGeneralField(
    loaderId: string,
    generalFieldId: number,
    generalField: GeneralFieldsDTO,
  ) {
    return this._httpClient.put(
      `${this._baseUrl}/general-fields/${generalFieldId}`,
      generalField,
      null,
      loaderId,
    );
  }

  deleteGeneralField(loaderId: string, generalFieldId: number) {
    return this._httpClient.delete<PagedResponse<GeneralFieldsDTO>>(
      `${this._baseUrl}/general-fields/${generalFieldId}`,
      {},
      loaderId,
    );
  }
}
